/**
 * Created by agengmaulana on 4/28/17.
 */
import React from 'react'
import Prokontra_Comment_Btn from './prokontra_comment_btn'
import styles from './../../assets/css/comment.css'
import {observer} from "mobx-react"


@observer
export default class Prokontra_Comment_Share extends React.Component {

    constructor(props) {
        super(props)

    }

    render() {
        const {datFunction, content} = this.props
        return (
            <span >
                <Prokontra_Comment_Btn class="dk_icon-facebook" share_to="fb" id={this.props.id} click={() => datFunction.shareFb(content,this.props.id)} target="_blank" title="Share This on Facebook" />&nbsp;
                <Prokontra_Comment_Btn class="dk_icon-twitter" share_to="tw" id={this.props.id} click={this.onClick} datFunction={datFunction}
                             target="_blank" title="Share This on Twitter"/>
            </span>

        )
    }


    onClick=()=>{

        this.props.datFunction.dataShortUrl(this.props.content, this.props.id)
        // this.props.datFunction.shareGroup(this.props.content, this.props.datFunction.dataShort);
    }




}




// WEBPACK FOOTER //
// ./static/src/component/prokontra_comment_share/prokontra_comment_share.js